import React from 'react';

import ErrorPage from '~/components/ErrorPage';
import { createTranslate } from '~/utils/translation';

import notFound from 'images/404.svg';


const tt = createTranslate('routes.not_found');


const NotFound = () => (
  <ErrorPage
    modifier="notFound"
    wrapAction={false}
    image={notFound}
    title={tt('title')}
    subtitle={tt('subtitle')}
    action={{ label: tt('back_home'), href: '/' }}
  />
);


export default NotFound;
